import {
  SettingsFormControl,
  TextInputField
} from '@sequencehq/core-components'

import { Merchant, useMerchantSettings } from './useMerchantSettings'
import { BASE_INPUT_FIELD_STYLES } from 'SettingsV2/settings.constants'

export const MerchantSettings = (props: { merchant: Merchant }) => {
  const { getInputFieldProps } = useMerchantSettings(props.merchant)

  return (
    <>
      <SettingsFormControl label="Company name" htmlFor="company-name">
        <TextInputField
          {...BASE_INPUT_FIELD_STYLES}
          {...getInputFieldProps('legalCompanyName', {
            label: 'Company name',
            id: 'company-name',
            placeholder: 'Acme, inc.'
          })}
        />
      </SettingsFormControl>
      <SettingsFormControl label="Company email" htmlFor="company-email">
        <TextInputField
          type="email"
          {...BASE_INPUT_FIELD_STYLES}
          {...getInputFieldProps('email', {
            placeholder: 'hello@example.com',
            id: 'company-email',
            label: 'Company email'
          })}
        />
      </SettingsFormControl>
      <SettingsFormControl label="URL" htmlFor="company-url">
        <TextInputField
          {...BASE_INPUT_FIELD_STYLES}
          {...getInputFieldProps('appUrl', {
            placeholder: 'https://',
            id: 'company-url',
            label: 'Company URL'
          })}
        />
      </SettingsFormControl>
    </>
  )
}
